// import { ElMessage } from "element-plus";
import OSS from 'ali-oss'
import utils from "@/utils/utils"

// 上传方法，支持进度回调
const uploadFile = (file, option, mulu = 'znsign', onProgress) => {
  const client = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: option.accessKeyId,
    accessKeySecret: option.accessKeySecret,
    stsToken: option.securityToken,
    bucket: 'meimengapp'
  });

  const filePath = `${mulu}/${utils.guid() + file.name}`;

  // 使用 multipartUpload 支持进度
  return client.multipartUpload(filePath, file, {
    progress: (percentage) => {
      if (onProgress && typeof onProgress === 'function') {
        onProgress(+(percentage * 100).toFixed(2)); // 例如 45.32
      }
    }
  });
};

export default uploadFile;
